import { TRootState } from '@/redux/rootReducer';
import {
  getImageCategoryTabs,
  TImageCategories,
  transformCampgroundImagesData,
} from '@/utility/rentals';

interface IGalleryHeader {
  items: TImageCategories;
}

export const getGalleryHeader = (state: TRootState): IGalleryHeader => ({
  items: getImageCategoryTabs(state.listing.data?.images),
});

export const getCampgroundGalleryHeader = (state: TRootState): IGalleryHeader => {
  const formattedImages = state.campgroundListing.data
    ? transformCampgroundImagesData(state.campgroundListing.data.images)
    : [];

  return {
    items: getImageCategoryTabs(formattedImages),
  };
};
